import { Paper, Typography } from "@mui/material";
import React from "react";
import { ReactComponent as LineIcon } from "../../../../assets/svg/Line.svg";
import styles from "../../styles";

export const getStatusDisplayText = (text) => {
  if (typeof text !== "string") return text;
  const displayText = text
    .replace(/[-_]/g, " ")
    .toLowerCase()
    .split(" ")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
  return displayText;
};

function Statistis({ details }) {
  const stats = [
    {
      label: "Budget",
      value: `${getStatusDisplayText(details?.budgetType)}`,
    },
    { label: "No. of Bedrooms", value: details?.sizeMetadata },
    { label: "Duration", value: details?.timeline },
  ];

  return (
    <>
      <div style={styles.rowFlex}>
        {stats?.map((stat, index) => (
          <div style={{ width: "100%" }} key={index}>
            <Paper style={styles.stats_section}>
              {index !== 0 ? <LineIcon /> : null}
              <div style={{ padding: index === 0 ? "1vh 0vw" : "1vh 4vw" }}>
                <Typography style={styles.stats_label}>
                  {stat?.label}
                </Typography>
                <Typography style={styles.stats_value}>
                  {stat.value ? stat?.value?.toLocaleString() : "---"}
                </Typography>
              </div>
            </Paper>
          </div>
        ))}
      </div>
    </>
  );
}

export default Statistis;
